import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Account, Roles, SsoAccountInfoModel } from '../../model/sso-account-info.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import { clearStaleMsalInteraction, isInteractionInProgressError, isUserCancelledError } from '../../msal-interaction.util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading: boolean = false;
  loginForm: FormGroup | any;
  username = new FormControl('', [Validators.required]);
  password = new FormControl('', [Validators.required]);
  hide = true;
  isIframe = false;
  loginDisplay = false;
  account: Account = {};
  isloading: boolean = false;

  private readonly _destroying$ = new Subject<void>();
  private tokenKey = 'auth-token';
  userGroups: any;

  constructor(
    private auth: AuthService,
    private router: Router,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private apiService: SharedDataService
  ) {

    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/dashboard']); // Change to the appropriate route
    }

    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],

    });
  }

  onSubmit(): void {
    const username = this.loginForm.get('username').value;
    const password = this.loginForm.get('password').value;

    this.loading = true;

    // localStorage.setItem(this.tokenKey, '12314424');
    // this.auth.setAuthenticatedStatus(true);
    // this.router.navigateByUrl('/dashboard');
    this.auth.login(username, password).subscribe({
      next: response => {
        this.loading = false;
        if (response.code !== 400 && response.data) {
          localStorage.setItem(this.tokenKey, response.data.token);
          // this.apiService.setApiCallTrigger(true);
          this.auth.setAuthenticatedStatus(true);
          this.router.navigateByUrl('dashboard');
        } else {
          this._snackBar.open(response.message, '', {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      error: error => {
        this.loading = false;
        this._snackBar.open('Network Error', '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        console.error('Login failed:', error.message);
      },
      complete: () => {
        // console.log('Request complete');
      }
    });

  }


  ngOnInit(): void {
    // Reaching the login page means nothing is in flight in this tab, so any flag left
    // behind by an earlier sign-out is stale and would block the next sign-in.
    clearStaleMsalInteraction();
    this.setLoginDisplay();
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  // loginRedirect() {
  //   if (this.msalGuardConfig.authRequest){
  //     this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);

  //   } else {
  //     this.authService.loginRedirect();
  //   }
  // }

  LoginSSO() {
    this.startSsoLogin(true);
  }

  private startSsoLogin(allowRetry: boolean) {
    this.loading = true;

    this.authService.loginPopup()
      .subscribe({
        next: (result) => {
          this.loading = false;
          localStorage.setItem(this.tokenKey, result.accessToken);
          if (result.account) {
            this.authService.instance.setActiveAccount(result.account);
          }
          this.setLoginDisplay();
          this.account.ssoAccountId = result?.account?.localAccountId
          this.account.accountId = result?.account?.username.split("@")[0]
          this.account.emailAddress = result?.account?.username
          this.account.fullName = result?.account?.name;
          const saveUserData = JSON.stringify(this.account);

          localStorage.setItem('user-information', saveUserData);
        },
        error: (error) => {
          this.loading = false;
          console.error('SSO login failed:', error);

          // A previous popup that was abandoned blocks every later login attempt.
          if (allowRetry && isInteractionInProgressError(error)) {
            clearStaleMsalInteraction();
            this.startSsoLogin(false);
            return;
          }

          clearStaleMsalInteraction();

          if (!isUserCancelledError(error)) {
            this._snackBar.open('Unable to sign in. Please try again.', 'Close', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 5000
            });
          }
        }
      });

  }



  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }




}
